import {
    green,
    blue,
    orange,
    red,
    purple,
    indigo,
    teal,
} from '@mui/material/colors'

interface AppColors {
    info: string
    success: string
    warning: string
    error: string
    chart: ChartColors
}

interface ChartColors {
    one: string
    two: string
    three: string
    four: string
    five: string
}

export const APP_COLORS = {
    info: blue[500],
    success: green[500],
    warning: orange[700],
    error: red[800],
    chart: {
        one: teal[200],
        two: indigo[200],
        three: blue[200],
        four: green[200],
        five: purple[200],
    } as ChartColors,
} as AppColors

export const getColor = (
    level: 'info' | 'success' | 'warning' | 'error'
): string => {
    switch (level) {
        case 'info':
            return APP_COLORS.info
        case 'success':
            return APP_COLORS.success
        case 'warning':
            return APP_COLORS.warning
        case 'error':
            return APP_COLORS.error
    }
}
